import { render, staticRenderFns } from "./towerRaceGame.vue?vue&type=template&id=2ed83eb0&"
import script from "./towerRaceGame.vue?vue&type=script&lang=js&"
export * from "./towerRaceGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports